var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "券类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.ticketType,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "ticketType", $$v)
                        },
                        expression: "searchInfo.ticketType"
                      }
                    },
                    _vm._l(_vm.ticketTypeOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "券名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.ticketName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "ticketName", $$v)
                      },
                      expression: "searchInfo.ticketName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "券编号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.ticketRuleNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "ticketRuleNo", $$v)
                      },
                      expression: "searchInfo.ticketRuleNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: {
                        click: function($event) {
                          return _vm.onAdd(1)
                        }
                      }
                    },
                    [_vm._v("满减券")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: {
                        click: function($event) {
                          return _vm.onAdd(2)
                        }
                      }
                    },
                    [_vm._v("折扣券")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "当现金用，可与任何券、商品优惠叠加",
                        placement: "top-start"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-plus" },
                          on: {
                            click: function($event) {
                              return _vm.onAdd(3)
                            }
                          }
                        },
                        [_vm._v("现金券")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-alert",
        {
          staticClass: "bairun-margin-b",
          attrs: { type: "success", closable: false }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(
              " 注意：现金券当现金用，可与任何券、油品优惠叠加；不同类型券之间不可叠加，同种类型可根据配置叠加，如：满减不可叠加满折、单升，满减只能叠加满减 "
            )
          ])
        ]
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "券编号", prop: "ticketRuleNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "券类型", prop: "ticketType" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.ticketType == 1
                      ? _c("span", [_vm._v("满减券")])
                      : _vm._e(),
                    scope.row.ticketType == 2
                      ? _c("span", [_vm._v("折扣券")])
                      : _vm._e(),
                    scope.row.ticketType == 3
                      ? _c("span", [_vm._v("现金券")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "券名称", prop: "ticketName" }
          }),
          _c("el-table-column", {
            attrs: { label: "券面额", prop: "ticketValue" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.ticketType == 1
                      ? _c("span", [
                          _vm._v(_vm._s(scope.row.ticketValue) + "元")
                        ])
                      : _vm._e(),
                    scope.row.ticketType == 2
                      ? _c("span", [
                          _vm._v(_vm._s(scope.row.ticketValue) + "折")
                        ])
                      : _vm._e(),
                    scope.row.ticketType == 3
                      ? _c("span", [
                          _vm._v(_vm._s(scope.row.ticketValue) + "元")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "可用店铺", prop: "sellerName" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onViewSeller(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "可用商品", prop: "limitGoods" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onViewGoods(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "CreatedAt", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("变更")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewFullReduceDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewFullReduceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "便利店配置" } }),
                          _c("el-step", { attrs: { title: "商品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.viewFullReduceDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        { attrs: { label: "券面额：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加其他券：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitAddTicket,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddTicket",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddTicket"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不可叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可与任何满减券叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("只能和本规则的券叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitAddTicket == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "最多叠加张数：" } },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 1,
                                              clearable: "",
                                              placeholder: "请输入张数"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.formData.addTicketNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "addTicketNum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.addTicketNum"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否重复领取：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限首单：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "时间类型：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.ticketTimeType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "ticketTimeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.ticketTimeType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("指定时间")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("领取之日起n天有效")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.ticketTimeType == 0
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "有效日期:" } },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "daterange",
                                              align: "right",
                                              "unlink-panels": "",
                                              "range-separator": "至",
                                              "start-placeholder":
                                                "开始(含当天)",
                                              "end-placeholder": "结束(含当天)",
                                              format: "yyyy-MM-dd",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            model: {
                                              value: _vm.dateRangeValueArr,
                                              callback: function($$v) {
                                                _vm.dateRangeValueArr = $$v
                                              },
                                              expression: "dateRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "每天时间:" } },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.ticketTimeType == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "有效天数：" } },
                                        [
                                          _c("el-input-number", {
                                            model: {
                                              value: _vm.formData.limitDays,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitDays",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitDays"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("天")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "每天时间:" } },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否选择出资方" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出资方比例：" } },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "ticket-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限店铺：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用店铺:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限商品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewDiscountDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewDiscountDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "便利店配置" } }),
                          _c("el-step", { attrs: { title: "商品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.viewDiscountDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        { attrs: { label: "券折扣：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("折")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "最高优惠：" } },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "bairun-underline-input",
                                        attrs: { controls: false },
                                        model: {
                                          value: _vm.formData.maxDiscountValue,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "maxDiscountValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.maxDiscountValue"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否叠加其他券：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitAddTicket,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddTicket",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddTicket"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不可叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可与任何折扣券叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("只能和本规则的券叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitAddTicket == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "最多叠加张数：",
                                            prop: "addTicketNum"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 1,
                                              clearable: "",
                                              placeholder: "请输入张数"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.formData.addTicketNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "addTicketNum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.addTicketNum"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否重复领取：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限首单：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "时间类型：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.ticketTimeType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "ticketTimeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.ticketTimeType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("指定时间")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("领取之日起n天有效")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.ticketTimeType == 0
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "有效日期:" } },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "daterange",
                                              align: "right",
                                              "unlink-panels": "",
                                              "range-separator": "至",
                                              "start-placeholder":
                                                "开始(含当天)",
                                              "end-placeholder": "结束(含当天)",
                                              format: "yyyy-MM-dd",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            model: {
                                              value: _vm.dateRangeValueArr,
                                              callback: function($$v) {
                                                _vm.dateRangeValueArr = $$v
                                              },
                                              expression: "dateRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "每天时间:" } },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.ticketTimeType == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "有效天数：" } },
                                        [
                                          _c("el-input-number", {
                                            model: {
                                              value: _vm.formData.limitDays,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitDays",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitDays"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("天")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "每天时间:" } },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否选择出资方" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出资方比例：" } },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "ticket-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限店铺：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用店铺:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限商品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewCashDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewCashDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "便利店配置" } }),
                          _c("el-step", { attrs: { title: "商品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.viewCashDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        { attrs: { label: "券面额：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "限额：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品金额满：" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: { controls: false },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否重复领取：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "时间类型：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.ticketTimeType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "ticketTimeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.ticketTimeType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("指定时间")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("领取之日起n天有效")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.ticketTimeType == 0
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "有效日期:" } },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "daterange",
                                              align: "right",
                                              "unlink-panels": "",
                                              "range-separator": "至",
                                              "start-placeholder":
                                                "开始(含当天)",
                                              "end-placeholder": "结束(含当天)",
                                              format: "yyyy-MM-dd",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            model: {
                                              value: _vm.dateRangeValueArr,
                                              callback: function($$v) {
                                                _vm.dateRangeValueArr = $$v
                                              },
                                              expression: "dateRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "每天时间:" } },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.ticketTimeType == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "有效天数：" } },
                                        [
                                          _c("el-input-number", {
                                            model: {
                                              value: _vm.formData.limitDays,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitDays",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitDays"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("天")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "每天时间:" } },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每周时间:" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否选择出资方" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出资方比例：" } },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "ticket-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "备注：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限店铺：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "可用店铺:" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "是否限商品：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "20" },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addFullReduceDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addFullReduceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "便利店配置" } }),
                          _c("el-step", { attrs: { title: "商品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "券名称：",
                                        prop: "ticketName"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          },
                                          change: _vm.getDescribe
                                        },
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.addFullReduceDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "券面额：",
                                            prop: "ticketValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              controls: false,
                                              min: 0
                                            },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "限额：",
                                        prop: "limitSales"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "商品金额满：",
                                            prop: "limitSalesValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              controls: false,
                                              min: 0
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              },
                                              change: _vm.getDescribe
                                            },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "商品金额满：",
                                            prop: "limitSalesValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              controls: false
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              },
                                              change: _vm.getDescribe
                                            },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否叠加其他券：",
                                        prop: "limitAddTicket"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitAddTicket,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddTicket",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddTicket"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不可叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可与任何满减券叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("只能和本规则的券叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitAddTicket == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "最多叠加张数：",
                                            prop: "addTicketNum"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 1,
                                              clearable: "",
                                              placeholder: "请输入张数"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.formData.addTicketNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "addTicketNum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.addTicketNum"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否重复领取：",
                                        prop: "limitReceive"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否限首单：",
                                        prop: "limitFirstUse"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "时间类型：",
                                        prop: "ticketTimeType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.ticketTimeType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "ticketTimeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.ticketTimeType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("指定时间")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("领取之日起n天有效")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.ticketTimeType == 0
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "有效日期:",
                                            prop: "dateRangeValueArr"
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "daterange",
                                              align: "right",
                                              "unlink-panels": "",
                                              "range-separator": "至",
                                              "start-placeholder":
                                                "开始(含当天)",
                                              "end-placeholder": "结束(含当天)",
                                              format: "yyyy-MM-dd",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            model: {
                                              value: _vm.dateRangeValueArr,
                                              callback: function($$v) {
                                                _vm.dateRangeValueArr = $$v
                                              },
                                              expression: "dateRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: { label: "每天时间:" }
                                        },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.ticketTimeType == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "有效天数：",
                                            prop: "limitDays"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              min: 1
                                            },
                                            model: {
                                              value: _vm.formData.limitDays,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitDays",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitDays"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("天")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: { label: "每天时间:" }
                                        },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "每周时间:",
                                        prop: "cycleDays"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: _vm.handleCheckWeekAllChange
                                          },
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          on: {
                                            change: _vm.handleCheckedWeekChange
                                          },
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否选择出资方",
                                        prop: "isCapital"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "出资方比例：",
                                            prop: "ticketDiscountCapitalRule"
                                          }
                                        },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "ticket-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: "备注：", prop: "remark" }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          },
                                          change: _vm.getDescribe
                                        },
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否限店铺：",
                                        prop: "limitSellers"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "可用店铺:",
                                            prop: "sellerList"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              on: {
                                                change:
                                                  _vm.handleSellerCheckAllChange
                                              },
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              on: {
                                                change:
                                                  _vm.handleCheckedSellerChange
                                              },
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否限商品：",
                                        prop: "limitGoods"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-add"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onAddGoods(
                                                    "activityGoods"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("添加商品")]
                                          ),
                                          _c("br"),
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "操作",
                                                  width: "60px"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c("el-button", {
                                                            attrs: {
                                                              icon:
                                                                "el-icon-close",
                                                              size: "mini",
                                                              circle: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDelActivityGoods(
                                                                  scope.row
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2275223852
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "自动填充，可自行修改",
                                      rows: "20"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addDiscountDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addDiscountDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "便利店配置" } }),
                          _c("el-step", { attrs: { title: "商品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "券名称：",
                                        prop: "ticketName"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          },
                                          change: _vm.getDescribe
                                        },
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.addDiscountDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "券折扣：",
                                            prop: "ticketValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "0.9为9折",
                                              controls: false,
                                              min: 0,
                                              max: 1
                                            },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix",
                                              staticStyle: { right: "-160px" }
                                            },
                                            [
                                              _vm._v("折    "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" }
                                                },
                                                [_vm._v("（注意：0.9为9折）")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "限额：",
                                        prop: "limitSales"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "商品金额满：",
                                            prop: "limitSalesValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              controls: false,
                                              min: 0
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              },
                                              change: _vm.getDescribe
                                            },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "商品金额满：",
                                            prop: "limitSalesValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              controls: false,
                                              min: 0
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              },
                                              change: _vm.getDescribe
                                            },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "最高优惠：",
                                        prop: "maxDiscountValue"
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "bairun-underline-input",
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请输入",
                                          controls: false,
                                          min: 0
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          },
                                          change: _vm.getDescribe
                                        },
                                        model: {
                                          value: _vm.formData.maxDiscountValue,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "maxDiscountValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.maxDiscountValue"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否叠加其他券：",
                                        prop: "limitAddTicket"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitAddTicket,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitAddTicket",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.limitAddTicket"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不可叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("可与任何折扣券叠加")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("只能和本规则的券叠加")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitAddTicket == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "最多叠加张数：",
                                            prop: "addTicketNum"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 1,
                                              clearable: "",
                                              placeholder: "请输入张数"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.formData.addTicketNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "addTicketNum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.addTicketNum"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否重复领取：",
                                        prop: "limitReceive"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否限首单：",
                                        prop: "limitFirstUse"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitFirstUse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitFirstUse",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitFirstUse"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("限首单使用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "时间类型：",
                                        prop: "ticketTimeType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.ticketTimeType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "ticketTimeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.ticketTimeType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("指定时间")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("领取之日起n天有效")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.ticketTimeType == 0
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "有效日期:",
                                            prop: "dateRangeValueArr"
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "daterange",
                                              align: "right",
                                              "unlink-panels": "",
                                              "range-separator": "至",
                                              "start-placeholder":
                                                "开始(含当天)",
                                              "end-placeholder": "结束(含当天)",
                                              format: "yyyy-MM-dd",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            model: {
                                              value: _vm.dateRangeValueArr,
                                              callback: function($$v) {
                                                _vm.dateRangeValueArr = $$v
                                              },
                                              expression: "dateRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: { label: "每天时间:" }
                                        },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.ticketTimeType == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "有效天数：",
                                            prop: "limitDays"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入"
                                            },
                                            model: {
                                              value: _vm.formData.limitDays,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitDays",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitDays"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("天")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: { label: "每天时间:" }
                                        },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "每周时间:",
                                        prop: "cycleDays"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: _vm.handleCheckWeekAllChange
                                          },
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          on: {
                                            change: _vm.handleCheckedWeekChange
                                          },
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否选择出资方",
                                        prop: "isCapital"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "出资方比例：",
                                            prop: "ticketDiscountCapitalRule"
                                          }
                                        },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "ticket-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: "备注：", prop: "remark" }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          },
                                          change: _vm.getDescribe
                                        },
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否限店铺：",
                                        prop: "limitSellers"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "可用店铺:",
                                            prop: "sellerList"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              on: {
                                                change:
                                                  _vm.handleSellerCheckAllChange
                                              },
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              on: {
                                                change:
                                                  _vm.handleCheckedSellerChange
                                              },
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否限商品：",
                                        prop: "limitGoods"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-add"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onAddGoods(
                                                    "activityGoods"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("添加商品")]
                                          ),
                                          _c("br"),
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "操作",
                                                  width: "60px"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c("el-button", {
                                                            attrs: {
                                                              icon:
                                                                "el-icon-close",
                                                              size: "mini",
                                                              circle: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDelActivityGoods(
                                                                  scope.row
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2275223852
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "自动填充，可自行修改",
                                      rows: "20"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addCashDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-ticket-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addCashDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            active: _vm.stepActive,
                            "finish-status": "success",
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "规则配置" } }),
                          _c("el-step", { attrs: { title: "便利店配置" } }),
                          _c("el-step", { attrs: { title: "商品配置" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right",
                            "label-width": "150px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "券名称：",
                                        prop: "ticketName"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          },
                                          change: _vm.getDescribe
                                        },
                                        model: {
                                          value: _vm.formData.ticketName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "ticketName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.ticketName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _vm.addCashDialogVisible
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "券面额：",
                                            prop: "ticketValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              controls: false,
                                              min: 0
                                            },
                                            model: {
                                              value: _vm.formData.ticketValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ticketValue",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ticketValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "限额：",
                                        prop: "limitSales"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitSales,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSales",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSales"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("不限")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSales == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "商品金额满：",
                                            prop: "limitSalesValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              controls: false,
                                              min: 0
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              },
                                              change: _vm.getDescribe
                                            },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("元可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.limitSales == 2
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "商品金额满：",
                                            prop: "limitSalesValue"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "bairun-underline-input",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              controls: false
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.inputChange($event)
                                              },
                                              change: _vm.getDescribe
                                            },
                                            model: {
                                              value:
                                                _vm.formData.limitSalesValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitSalesValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.limitSalesValue"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("件可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否重复领取：",
                                        prop: "limitReceive"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.limitReceive,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitReceive",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitReceive"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("可重复领取")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("不可重复领取")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "top-start"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content"
                                            },
                                            [
                                              _vm._v(
                                                "1、未使用过期可重复领取,已使用不能再领取"
                                              ),
                                              _c("br"),
                                              _vm._v("2、批量送券功能不限制"),
                                              _c("br"),
                                              _vm._v(
                                                "3、一个活动配置多张不限制，活动第二次领取时限制"
                                              )
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                            staticStyle: {
                                              "margin-left": "5px",
                                              color: "#606266"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "时间类型：",
                                        prop: "ticketTimeType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.ticketTimeType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "ticketTimeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.ticketTimeType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("指定时间")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("领取之日起n天有效")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.ticketTimeType == 0
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "有效日期:",
                                            prop: "dateRangeValueArr"
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "daterange",
                                              align: "right",
                                              "unlink-panels": "",
                                              "range-separator": "至",
                                              "start-placeholder":
                                                "开始(含当天)",
                                              "end-placeholder": "结束(含当天)",
                                              format: "yyyy-MM-dd",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            model: {
                                              value: _vm.dateRangeValueArr,
                                              callback: function($$v) {
                                                _vm.dateRangeValueArr = $$v
                                              },
                                              expression: "dateRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: { label: "每天时间:" }
                                        },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.ticketTimeType == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "有效天数：",
                                            prop: "limitDays"
                                          }
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              min: 1
                                            },
                                            model: {
                                              value: _vm.formData.limitDays,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitDays",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitDays"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "bairun-form-item-label-suffix"
                                            },
                                            [_vm._v("天")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: { label: "每天时间:" }
                                        },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              "is-range": "",
                                              "range-separator": "至",
                                              "start-placeholder": "开始时间",
                                              "end-placeholder": "结束时间",
                                              placeholder: "选择时间范围",
                                              format: "HH:mm:ss",
                                              "value-format": "HH:mm:ss"
                                            },
                                            on: { change: _vm.getDescribe },
                                            model: {
                                              value: _vm.timeRangeValueArr,
                                              callback: function($$v) {
                                                _vm.timeRangeValueArr = $$v
                                              },
                                              expression: "timeRangeValueArr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "每周时间:",
                                        prop: "cycleDays"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: _vm.handleCheckWeekAllChange
                                          },
                                          model: {
                                            value: _vm.weekCheckAll,
                                            callback: function($$v) {
                                              _vm.weekCheckAll = $$v
                                            },
                                            expression: "weekCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          on: {
                                            change: _vm.handleCheckedWeekChange
                                          },
                                          model: {
                                            value: _vm.weekChecked,
                                            callback: function($$v) {
                                              _vm.weekChecked = $$v
                                            },
                                            expression: "weekChecked"
                                          }
                                        },
                                        _vm._l(_vm.weekOptions, function(week) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: week.value,
                                              attrs: { label: week.value }
                                            },
                                            [_vm._v(_vm._s(week.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否选择出资方",
                                        prop: "isCapital"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isCapital,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isCapital",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isCapital"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.isCapital == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "出资方比例：",
                                            prop: "ticketDiscountCapitalRule"
                                          }
                                        },
                                        _vm._l(
                                          _vm.formData
                                            .ticketDiscountCapitalRule,
                                          function(item, index) {
                                            return _c(
                                              "el-row",
                                              {
                                                staticClass: "ticket-form-item"
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "出资方"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择出资方"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.capitaChange
                                                            },
                                                            model: {
                                                              value:
                                                                item.capitalId,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "capitalId",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.capitalId"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.CapitalRelationList,
                                                            function(item2) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    item2.capitalId,
                                                                  attrs: {
                                                                    label:
                                                                      item2.capitalName,
                                                                    value:
                                                                      item2.capitalId
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 10 } },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "比例占比（%）"
                                                        }
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入比例",
                                                            min: 1,
                                                            max: 100
                                                          },
                                                          model: {
                                                            value:
                                                              item.capitalValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "capitalValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.capitalValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: "备注：", prop: "remark" }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          },
                                          change: _vm.getDescribe
                                        },
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 2
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否限店铺：",
                                        prop: "limitSellers"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitSellers,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitSellers",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitSellers"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部店铺可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分店铺可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitSellers == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "bairun-required",
                                          attrs: {
                                            label: "可用店铺:",
                                            prop: "sellerList"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              on: {
                                                change:
                                                  _vm.handleSellerCheckAllChange
                                              },
                                              model: {
                                                value: _vm.sellerCheckAll,
                                                callback: function($$v) {
                                                  _vm.sellerCheckAll = $$v
                                                },
                                                expression: "sellerCheckAll"
                                              }
                                            },
                                            [_vm._v("全选")]
                                          ),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              on: {
                                                change:
                                                  _vm.handleCheckedSellerChange
                                              },
                                              model: {
                                                value: _vm.sellerIdChecked,
                                                callback: function($$v) {
                                                  _vm.sellerIdChecked = $$v
                                                },
                                                expression: "sellerIdChecked"
                                              }
                                            },
                                            _vm._l(_vm.sellerOptions, function(
                                              item
                                            ) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: item.sellerId,
                                                  attrs: {
                                                    label: item.sellerId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.sellerName)
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.stepActive == 3
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "是否限商品：",
                                        prop: "limitGoods"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          on: { change: _vm.getDescribe },
                                          model: {
                                            value: _vm.formData.limitGoods,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitGoods",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitGoods"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("全部商品可用")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("部分商品可用")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.formData.limitGoods == 1
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "已选商品：" } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-add"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onAddGoods(
                                                    "activityGoods"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("添加商品")]
                                          ),
                                          _c("br"),
                                          _c(
                                            "el-table",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                data: _vm.activityGoodsList,
                                                border: "",
                                                stripe: "",
                                                "tooltip-effect": "dark"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "商品名称",
                                                  prop: "goodsName"
                                                }
                                              }),
                                              _c("el-table-column", {
                                                attrs: {
                                                  label: "操作",
                                                  width: "60px"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(scope) {
                                                        return [
                                                          _c("el-button", {
                                                            attrs: {
                                                              icon:
                                                                "el-icon-close",
                                                              size: "mini",
                                                              circle: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDelActivityGoods(
                                                                  scope.row
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2275223852
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "describe" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v("券规则描述"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "（将在用户端展示，自动填充，可自行修改）"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "自动填充，可自行修改",
                                      rows: "20"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.describe,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "describe", $$v)
                                      },
                                      expression: "formData.describe"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.goodsComponentFormData.dialogVisible
        ? _c("SpuSelectComponent", {
            ref: "GoodsSelectComponent",
            attrs: { "goods-component-form-data": _vm.goodsComponentFormData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }